<template>
  <div class="pricing-bands">
    <table v-if="bands && bands.length">
      <thead>
        <tr>
          <th v-for="(band, index) in bands"
              :key="index">
            <template v-if="band.quantityLower === band.quantityHigher">
              {{ band.quantityLower }}
            </template>
            <template v-else>
              <template v-if="band.quantityHigher > 0">
                {{ band.quantityLower }}-{{ band.quantityHigher }}
              </template>
              <template v-else>
                {{ band.quantityLower }}+
              </template>
            </template>

            {{ renderItemText(band) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="(band, index) in bands"
              :key="index">
            {{ renderPrice(band.priceExcVat) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { EcommerceModule } from "spiritweb.packages.ecommerce";

export default {
  name: "PricingBandsTable",
  props: {
    bands: {
      type: Array,
      default: null
    }
  },
  methods: {
    renderPrice ( price ) {
      return EcommerceModule.renderPrice( price, "gbp", "en-gb" );
    },
    renderItemText ( band ) {
      let result = "item";

      if ( band.quantityLower > 1 ) {
        result += "s";
      }

      return result;
    }
  }
};
</script>

<style lang="less" scoped>
table {
  width: 100%;
  text-align: center;
}

table, th, td {
  border: 1px solid lightgray;
}

th, td {
  padding: 5px 10px;
}
</style>
